module.exports = __webpack_public_path__ + "img/icon_recommend.6f7dc1a9.svg";